import { TerminalEventMonitoring } from '@lightspeed-payments/payments-terminal-sdk'
import { LSPAY_DATADOG_CLIENT_TOKEN } from './lspayConstants'

export const getMonitoringInstance = (
  outletId: string,
  isSandbox: boolean,
  integrationType: 'LOCAL' | 'CLOUD'
) =>
  TerminalEventMonitoring.init({
    clientToken: LSPAY_DATADOG_CLIENT_TOKEN,
    env: isSandbox ? 'STAGE' : 'PROD',
    product: 'XSERIES',
    pli: getPli(outletId),
    processor: 'STRIPE',
    integrationType,
    platformType: 'WEB',
    verbose: isSandbox,
  })

const getPli = (outletId: string): string => {
  return 'lsx:' + outletId
}
